import axios from 'axios';
import { useURL } from "../../utility/hooks/useURL";
const { getUrl } = useURL();

const getPeddingDailyEvauation = async () => {
  const { data } = await axios.get(
    `${getUrl()}/answers/pending_daily_evaluations`,
  );

  return data;
};

const showAnswer = async (answerId, patientId) => {
  const { data } = await axios.get(
    `${getUrl()}/patients/${patientId}/answers/${answerId}`,
  );

  return data;
};

const updateDailyEvaluation = async (patientId, data, id) => {
  const resp = await axios
    .put(`${getUrl()}patients/${patientId}/answers/${id}`, data)
    .then((response) => response);

  return resp;
}

const createDailyEvaluation = async (patientId) => {

  const data = {
    answer: {
      patient_id: patientId
    }
  }

  const resp = await axios
    .post(`${getUrl()}patients/${patientId}/answers/create_pending_daily_evaluation`, data)
    .then((response) => response);

  return resp;
};


export { getPeddingDailyEvauation, updateDailyEvaluation, showAnswer, createDailyEvaluation };

